import { register } from '.';
import Cookies from 'js-cookie';

const COOKIE_NAME = '__nutrition-for-me-announcement';
const BODY_ACTIVE_CLASS = 'has-announcement-bar';
let $bar = $('.announcement-bar');
let b = document.body;

register('announcement-bar', {
  onLoad() {
    this.cookieName = this.getSectionIdWithHash.call(this)

    if (Cookies.get(this.cookieName) == 1 && $bar.length) {
      $bar.css('display', 'none');
      b.classList.remove(BODY_ACTIVE_CLASS)
    }

    $('.announcement-bar-toggle').on('click', e => {
      $bar.slideToggle();

      b.classList.remove(BODY_ACTIVE_CLASS);

      Cookies.set(this.cookieName, 1, { expires: 1 });
    });
  },

  getSectionIdWithHash() {
    return `${COOKIE_NAME}_${this.container.dataset.sectionId}`
  }
});


// document.addEventListener('DOMContentLoaded', init);



// WEBPACK FOOTER //
// ./scripts/sections/announcement-bar.js